import { createSlice } from "@reduxjs/toolkit"

export const posCartSlice = createSlice({
    name: "posCart",
    initialState: { isOpen: false },
    reducers: {
        setPosCartOpen: (state, action) => {
            state.isOpen = action.payload
        }
    }
})

export const {
    setPosCartOpen,
} = posCartSlice.actions